import React, { useState, useEffect } from 'react';
import { NotificationService } from '../../Utils/NotificationService';
import './NotificationPopup.css';

const NotificationPopup = ({ notification, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  // Remove the automatic marking as shown - let the parent handle it
  useEffect(() => {
    console.log('NotificationPopup mounted with:', notification);
  }, [notification]);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible || !notification) {
    return null;
  }

  return (
    <div className="notification-popup-overlay">
      <div className="notification-popup-container">
        <div className="notification-popup-header">
          <h4 className="notification-popup-title">
            {notification.title || 'Notification'}
          </h4>
          <button 
            className="notification-popup-close"
            onClick={handleClose}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
        
        <div className="notification-popup-body">
          <div className="notification-popup-message">
            {notification.message || notification.notification || 'No message content.'}
          </div>
        </div>
        
        <div className="notification-popup-footer">
          <button 
            className="notification-popup-btn"
            onClick={handleClose}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopup;